import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 md:mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "Personal Information")
], -1)
const _hoisted_2 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["name", "id", "onUpdate:modelValue", "disabled"]
const _hoisted_5 = ["name", "id", "onUpdate:modelValue"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-right pt-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-xs md:text-sm font-medium rounded-md text-white bg-sky hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky"
  }, " Save ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formConfig, ({ key, type, label, fullWidth, disabled }) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: _normalizeClass(["col-span-6", { 'sm:col-span-3': !fullWidth}])
          }, [
            _createElementVNode("label", {
              for: key,
              class: "block text-xs md:text-sm font-medium text-gray-700"
            }, _toDisplayString(label), 9, _hoisted_3),
            (type !== 'address' && key !== 'phoneNumber')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  name: key,
                  id: key,
                  class: _normalizeClass(["mt-1 h-10 px-3 md:px-4 border focus:ring-sky focus:border-sky block w-full shadow-sm text-xs sm:text-sm border-gray-300 rounded-md", { 'bg-gray-100 pointer-events-none': disabled }]),
                  "onUpdate:modelValue": ($event: any) => ((_ctx.modifiedData[key]) = $event),
                  disabled: disabled
                }, null, 10, _hoisted_4)), [
                  [_vModelText, _ctx.modifiedData[key]]
                ])
              : (key == 'phoneNumber')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "text",
                    name: key,
                    id: key,
                    class: _normalizeClass(["mt-1 h-10 px-3 md:px-4 border focus:ring-sky focus:border-sky block w-full shadow-sm text-xs sm:text-sm border-gray-300 rounded-md", { 'bg-gray-100 pointer-events-none': disabled }]),
                    "onUpdate:modelValue": ($event: any) => ((_ctx.modifiedData[key]) = $event)
                  }, null, 10, _hoisted_5)), [
                    [_directive_maska, '+1 (###) ###-####'],
                    [_vModelText, _ctx.modifiedData[key]]
                  ])
                : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _hoisted_6
    ], 32)
  ], 64))
}